export default __webpack_public_path__ + "static/board-b7a668f56d0dbdd84c1bcb4e8fe8ac97.jpg";